import { useState, useEffect } from 'react';

/**
 * Hook para gerenciar preferências do usuário armazenadas no localStorage
 * 
 * @returns {Object} - Funções e configurações de preferências do usuário
 */
export const useUserPreferences = () => {
  // Estado para armazenar as preferências do usuário
  const [preferences, setPreferences] = useState(() => {
    // Inicializar preferências do localStorage ou usar valores padrão
    const savedPrefs = localStorage.getItem('userPreferences');
    return savedPrefs ? JSON.parse(savedPrefs) : {
      // Valores padrão
      mobileColumns: 2, // Padrão: 2 colunas no mobile
      theme: 'light',
      notifications: true
    };
  });

  // Salvar preferências no localStorage quando mudarem
  useEffect(() => {
    localStorage.setItem('userPreferences', JSON.stringify(preferences));
  }, [preferences]);

  /**
   * Atualiza uma preferência específica do usuário
   * @param {string} key - Chave da preferência a ser atualizada
   * @param {any} value - Novo valor para a preferência
   */
  const updatePreference = (key, value) => {
    setPreferences(prevPrefs => ({
      ...prevPrefs,
      [key]: value
    }));
  };

  /**
   * Atualiza múltiplas preferências de uma vez
   * @param {Object} newPrefs - Objeto com múltiplas novas preferências
   */
  const updatePreferences = (newPrefs) => {
    setPreferences(prevPrefs => ({
      ...prevPrefs,
      ...newPrefs
    }));
  };

  /**
   * Redefine todas as preferências para os valores padrão
   */
  const resetPreferences = () => {
    const defaultPrefs = {
      mobileColumns: 2,
      theme: 'light',
      notifications: true
    };
    
    setPreferences(defaultPrefs);
  };

  return {
    preferences,
    updatePreference,
    updatePreferences,
    resetPreferences
  };
}; 